import type { ReactNode } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { fieldControlClassName } from '../../ui/input';
import { cn } from '../../../lib/utils';

export type ConsoleHeaderSelectOption = {
  value: string;
  label: string;
};

type ConsoleHeaderSelectProps = {
  value: string;
  options: ConsoleHeaderSelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  'aria-label': string;
  /** Slightly wider trigger for long labels (e.g. Enforcing). */
  minWidthClass?: string;
  placeholder?: ReactNode;
};

/** Header / toolbar-style select — matches grid role filter & search field chrome. */
export function ConsoleHeaderSelect({
  value,
  options,
  onChange,
  disabled,
  'aria-label': ariaLabel,
  minWidthClass = 'min-w-[7.5rem]',
  placeholder,
}: ConsoleHeaderSelectProps) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        className={cn(fieldControlClassName, 'tm-toolbar-select shrink-0', minWidthClass)}
        aria-label={ariaLabel}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent align="end" className="tm-toolbar-select-menu">
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            className="tm-toolbar-select-menu-item"
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
